import { useUrlState } from "./useUrlState.js";
//#region src/hooks/useTabsState.ts
function useTabsState(key, defaultTab) {
	const [tab, setTab] = useUrlState(key, defaultTab, { sessionStorage: true });
	return [tab, setTab];
}
//#endregion
export { useTabsState };

//# sourceMappingURL=useTabsState.js.map